import { Draft, produce } from 'immer';

import {
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_SUCCESS,
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_BY_DRAFT_REQUEST,
  CONTRACT_SETUP_BY_DRAFT_SUCCESS,
  CONTRACT_SETUP_PARTICIPANT_AUTHENTICATION_CHANGE,
} from '@app/store/actionTypes';
import {
  ContractSetupAction,
  contractSetupSetParticipants,
} from '@app/store/contract-setup/actions';

export interface PasswordState {
  [id: string]: {
    hint?: string;
    value?: string;
  };
}

const initialState: PasswordState = {};

const reducer = produce((draft: Draft<PasswordState>, action: ContractSetupAction) => {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
    case CONTRACT_SETUP_BY_DRAFT_REQUEST:
    case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_REQUEST:
      return initialState;
    case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_SUCCESS: {
      const { participants } = action.payload;
      participants.forEach((participant) => {
        const { participantId } = participant;
        draft[participantId] = {};
      });
      return draft;
    }
    case CONTRACT_SETUP_PARTICIPANT_AUTHENTICATION_CHANGE: {
      const { participantId, password } = action.payload;
      draft[participantId] = {
        hint: password.hint,
        value: password.value,
      };
      return draft;
    }
    case contractSetupSetParticipants.type: {
      const result: PasswordState = {};

      action.payload.forEach(({ participantId }) => {
        result[participantId] = draft[participantId] ?? {};
      });

      return result;
    }
    case CONTRACT_SETUP_BY_DRAFT_SUCCESS: {
      const { participants } = action.payload;
      participants.forEach(({ id, verification }) => {
        if (verification.password) {
          draft[id] = {
            value: verification.password.value,
          };
        } else {
          draft[id] = {};
        }
      });
      return draft;
    }
    default:
      return draft;
  }
}, initialState);

export default reducer;
